(() => {
  'use strict';
  if (window.NSContactPageInit) { window.NSContactPageInit(); return; }
  const controllers = new WeakMap();
  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-ns-contact]')];
    if (scope.matches?.('[data-ns-contact]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.nsContactReady) return;
      const form = root.querySelector('form'), topic = root.querySelector('[data-ns-contact-topic]');
      const order = root.querySelector('[data-ns-contact-order]'), orderInput = order?.querySelector('input');
      const label = root.querySelector('[data-ns-contact-topic-label]');
      if (!form || !topic || !order || !orderInput) return;
      const controller = new AbortController(), options = { signal: controller.signal };
      controllers.set(root, controller);
      function sync() {
        const isOrder = topic.value === 'order_shipping';
        order.hidden = !isOrder;
        orderInput.disabled = !isOrder;
        if (label) {
          label.disabled = !topic.value;
          label.value = topic.selectedOptions[0]?.textContent.trim() || '';
        }
      }
      topic.addEventListener('change', sync, options);
      root.querySelectorAll('[data-ns-contact-route]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const value = link.dataset.nsContactRoute;
          if (![...topic.options].some(option => option.value === value)) return;
          event.preventDefault();
          topic.value = value;
          topic.dispatchEvent(new Event('change', { bubbles: true }));
          form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          topic.focus({ preventScroll: true });
        }, options);
      });
      form.addEventListener('reset', () => setTimeout(() => { if (!controller.signal.aborted) sync(); }, 0), options);
      window.addEventListener('pageshow', sync, options);
      sync();
      root.dataset.nsContactReady = 'true';
      const status = root.querySelector('[data-ns-contact-status]');
      if (status) {
        requestAnimationFrame(() => {
          if (controller.signal.aborted) return;
          status.scrollIntoView({ block: 'center', behavior: 'auto' });
          status.focus({ preventScroll: true });
        });
      }
    });
  }
  window.NSContactPageInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-ns-contact]').forEach(root => {
      controllers.get(root)?.abort();
      controllers.delete(root);
      delete root.dataset.nsContactReady;
    });
  });
})();
